/* Aura Diamonds — product card image carousel. Delegated listeners so AJAX re-renders (collection filters, infinite scroll) keep working. */
(function () {
  if (window.__auraCardCarouselBound) return;
  window.__auraCardCarouselBound = true;

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest ? event.target.closest('.aura-card-carousel__arrow') : null;
    if (!arrow) return;

    event.preventDefault();
    event.stopPropagation();

    var carousel = arrow.closest('.aura-card-carousel');
    var track = carousel ? carousel.querySelector('.aura-card-carousel__track') : null;
    if (!track) return;

    var direction = arrow.getAttribute('data-dir') === 'prev' ? -1 : 1;
    track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track || !track.classList || !track.classList.contains('aura-card-carousel__track')) return;

      var carousel = track.closest('.aura-card-carousel');
      if (!carousel) return;

      var bar = carousel.querySelector('.aura-card-carousel__progress-bar');
      if (!bar) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;

      var progress = track.scrollLeft / maxScroll;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      var count = parseFloat(bar.parentNode.getAttribute('data-count')) || 1;
      bar.style.transform = 'translateX(' + progress * (count - 1) * 100 + '%)';
    },
    true
  );
})();
